<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="m15.75 8.25 1.5-1.5c-2.797-2.798-6.652-3.863-10.275-3.233L8.91 5.452a9.56 9.56 0 0 1 6.84 2.798Zm-1.5 1.5a7.421 7.421 0 0 0-2.79-1.748l2.265 2.265.525-.517Zm-7.5 3L9 15l2.25-2.25a3.178 3.178 0 0 0-4.5 0ZM2.558 1.23 1.5 2.287l2.288 2.288A11.777 11.777 0 0 0 .75 6.75l1.5 1.5a9.486 9.486 0 0 1 3.128-2.085l1.68 1.68A7.367 7.367 0 0 0 3.75 9.75l1.5 1.5a5.249 5.249 0 0 1 3.668-1.545l5.31 5.31 1.057-1.058L2.558 1.23Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
